"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processSuccess = exports.processErrors = exports.utilErrorToException = exports.isError = exports.getErrorMessage = exports.uniqueTypes = exports.filterField = exports.hasType = exports.hasField = exports.noResponse = exports.defaultError = exports._resolveError = exports.reduceErrors = void 0;
/* eslint-disable @typescript-eslint/comma-dangle */
const ui_1 = require("@app/component/ui");
const is_defined_1 = require("@app/util/is-defined");
const Sentry = __importStar(require("@sentry/browser"));
const react_1 = __importDefault(require("react"));
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const reset_store_1 = __importDefault(require("../action/reset-store"));
const error_type_1 = __importDefault(require("../const/error-type"));
const maybe_unwrap_1 = require("./apollo/maybe-unwrap");
const i18n_1 = require("./i18n");
const is_defined_2 = require("./is-defined");
const reduceErrors = (errors) => {
    if ((0, is_defined_1.isUndefined)(errors))
        return undefined;
    if (errors.length === 0) {
        return undefined;
    }
    const newErrors = errors
        .map((error) => {
        const errorName = error.path?.at(-1)?.toString() ?? '';
        return (0, exports._resolveError)(errorName, error);
    })
        .filter(is_defined_2.isDefined);
    // TODO reduce error of same type - so far backend doesnt send too much info about error type
    return newErrors;
};
exports.reduceErrors = reduceErrors;
const _resolveError = (request, error) => {
    if (error.message === 'Context creation failed: Invalid token') {
        // auth token no longer valid - call logOut()
        console.log('Auth token no longer valid. Reseting store and reloading the app.');
        (0, reset_store_1.default)();
        return {
            error: {
                request,
                type: error_type_1.default.API_ERR_INVALID_TOKEN,
                message: (0, i18n_1.t)('API_ERR_INVALID_TOKEN'),
            },
        };
    }
    if (error.message === 'Bad login') {
        return {
            error: {
                request,
                type: error_type_1.default.API_ERR_BAD_LOGIN,
                message: (0, i18n_1.t)('API_ERR_BAD_LOGIN'),
            },
        };
    }
    if (error.message === 'Same email already requested on this workspace') {
        return {
            error: {
                request,
                type: error_type_1.default.API_ERR_ALREADY_REQUESTED,
                message: (0, i18n_1.t)('API_ERR_ALREADY_REQUESTED'),
            },
        };
    }
    if (error.message === 'User email already exists on target workspace') {
        return {
            error: {
                request,
                type: error_type_1.default.API_ERR_ALREADY_MEMBER,
                message: (0, i18n_1.t)('API_ERR_ALREADY_MEMBER'),
            },
        };
    }
    if (error.message === 'Invalid token') {
        return {
            error: {
                request,
                type: error_type_1.default.API_ERR_INVALID_ACTIVATE,
                message: (0, i18n_1.t)('API_ERR_INVALID_ACTIVATE'),
            },
        };
    }
    if (error.message?.match('Invalid input: PATTERN should match pattern')) {
        return {
            error: {
                request,
                type: error_type_1.default.API_ERR_BAD_PHONE,
                message: (0, i18n_1.t)('API_ERR_BAD_PHONE'),
            },
        };
    }
    if (error.message?.match('Period duration must be between')) {
        return {
            error: {
                request,
                type: error_type_1.default.API_ERR_ILLEGAL_PERIOD_DURATION,
                message: (0, i18n_1.t)('API_ERR_ILLEGAL_PERIOD_DURATION'),
            },
        };
    }
    if (error.message === 'Not found: user') {
        // we don't really want to tell here
        // so we leave it as unknown error
        if (request === 'user-password-forgotten') {
            return (0, exports.defaultError)(request);
        }
        return {
            error: {
                request,
                type: error_type_1.default.API_ERR_USER_NOT_FOUND,
                message: (0, i18n_1.t)('API_ERR_USER_NOT_FOUND'),
            },
        };
    }
    if (error.message === 'You already answered') {
        return {
            error: {
                request,
                type: error_type_1.default.API_ERR_ALREADY_ANSWERED,
                message: (0, i18n_1.t)('API_ERR_ALREADY_ANSWERED'),
            },
        };
    }
    if (error.message === 'Error: Old password does not match.') {
        return {
            error: {
                request,
                type: error_type_1.default.API_ERR_WRONG_OLD_PASSWORD,
                message: (0, i18n_1.t)('API_ERR_WRONG_OLD_PASSWORD'),
            },
        };
    }
    if (error.message ===
        'Error: Cannot delete this shift, there are shifts created from this stand by shift.') {
        return {
            error: {
                request,
                type: error_type_1.default.API_ERR_CANT_DELETE_STANDBY,
                message: (0, i18n_1.t)('API_ERR_CANT_DELETE_STANDBY'),
            },
        };
    }
    return {
        error: {
            request,
            type: error_type_1.default.ERR_UNKNOWN,
            message: error.message,
            // the backend's own error code (`auth.email_not_verified`, `invite.otp_invalid`, …).
            // Nothing above maps to a dedicated type, so this is the only thing callers can
            // branch on when they want to render an expected failure instead of toasting it.
            code: error.extensions?.code,
        },
    };
};
exports._resolveError = _resolveError;
const defaultError = (request, message, code) => {
    return {
        error: {
            type: error_type_1.default.ERR_UNKNOWN,
            request,
            message,
            code,
        },
    };
};
exports.defaultError = defaultError;
const noResponse = () => {
    return {
        error: {
            type: error_type_1.default.API_ERR_NO_RESPONSE,
        },
    };
};
exports.noResponse = noResponse;
// view helpers
const hasField = (field, errors) => {
    return !!errors.find((err) => err.field === field);
};
exports.hasField = hasField;
const hasType = (type, errors) => {
    return !!errors.find((err) => err.type === type);
};
exports.hasType = hasType;
const filterField = (field, errors) => {
    return errors.filter((err) => err.field !== field);
};
exports.filterField = filterField;
// typically for missing-requires, potentially other types
// avoid multiple errors of same type in common error areas
const uniqueTypes = (errors) => {
    return errors.reduce((acc, err) => {
        if ((0, exports.hasType)(err.type, acc))
            return acc;
        return [...acc, err];
    }, []);
};
exports.uniqueTypes = uniqueTypes;
const getErrorMessage = (errVal) => {
    for (let i = 0; i < Object.keys(error_type_1.default).length; i++) {
        const k = Object.keys(error_type_1.default)[i];
        if (error_type_1.default[k] === errVal) {
            return (0, i18n_1.t)(k) ?? undefined;
        }
    }
};
exports.getErrorMessage = getErrorMessage;
const isError = (t) => typeof t === 'object' && t !== null && 'error' in t;
exports.isError = isError;
const utilErrorToException = (utilError) => {
    const errorMessage = (0, maybe_unwrap_1.unwrapMaybe)(utilError.error.message);
    const request = (0, maybe_unwrap_1.unwrapMaybe)(utilError.error.request);
    const code = (0, maybe_unwrap_1.unwrapMaybe)(utilError.error.code);
    const detailParts = [
        errorMessage,
        (0, is_defined_2.isDefined)(request) ? `request: ${request}` : undefined,
        (0, is_defined_2.isDefined)(code) ? `code: ${code}` : undefined,
    ].filter(is_defined_2.isDefined);
    const exception = new Error(`UtilError:${utilError.error.type}`);
    exception.name =
        detailParts.length > 0 ? detailParts.join(' | ') : 'no error information';
    return exception;
};
exports.utilErrorToException = utilErrorToException;
const processErrors = (errors, errorText = (0, i18n_1.t)('ERROR_SCREEN_TITLE'), variables) => {
    if ((0, is_defined_2.isDefined)(errors)) {
        errors.forEach((error) => {
            const errorMessage = (0, maybe_unwrap_1.unwrapMaybe)(error.error.message);
            const exception = (0, exports.utilErrorToException)(error);
            Sentry.captureException(exception, (scope) => {
                scope.setTag('scope', 'processErrors');
                scope.setExtra('utilError', error);
                if ((0, is_defined_1.isValue)(variables)) {
                    scope.setExtra('variables', variables);
                }
                return scope;
            });
            react_hot_toast_1.default.custom(() => (react_1.default.createElement(ui_1.Alert, { type: 'ERROR', text: `${errorText}${(0, is_defined_2.isDefined)(errorMessage) ? `: ${errorMessage}` : ''}` })));
        });
    }
};
exports.processErrors = processErrors;
const processSuccess = (message) => {
    react_hot_toast_1.default.custom(() => react_1.default.createElement(ui_1.Alert, { type: 'SUCCESS', text: message }));
};
exports.processSuccess = processSuccess;
